export default __webpack_public_path__ + "static/media/elefantes-quadro.09fbb6d7.png";